import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolRoleSup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1088_5801)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.11539 1.96502L5.68213 1.15384H10.2161L10.8846 1.99599L7.99058 4.61538L5.11539 1.96502Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.98259 3.46152L6.26923 5.08699L5.38208 9.23075L3.28084 7.9508L4.5234 5.67589H4.18636C3.53707 5.67589 2.8942 5.50187 2.29726 5.1513C1.67736 4.78813 0.94082 4.23075 0.5 3.46152H4.98259Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0176 3.46152L9.73077 5.08699L10.6181 9.23075L12.7187 7.9508L11.476 5.67589H11.7111C12.4872 5.67589 13.2551 5.44891 13.9569 4.9962C14.5144 4.6368 15.1179 4.1286 15.5 3.46152H11.0176Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.99013 6.34028L8.50869 5.78691L9.73077 12.7238L7.95584 13.8461L6.26923 12.7092L7.49028 5.76923L7.99013 6.34028Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1088_5801",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgLolRoleSup;
